import React from "react";
import "../HomeProduct.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaShieldAlt,
    FaBrain,
    FaLock,
    FaLaptopCode,
    FaServer,
    FaUsb,
    FaChartLine,
    FaSyncAlt,
    FaArrowRight,
} from "react-icons/fa";

// Replace this with your own product image later
import productImage from "../../assets/dashboard-2.jfif";

const features = [
    {
        icon: <FaBrain />,
        title: "AI-Powered Threat Detection",
    },
    {
        icon: <FaLock />,
        title: "Advanced Ransomware Protection",
    },
    {
        icon: <FaLaptopCode />,
        title: "Real-Time Endpoint Monitoring",
    },
    {
        icon: <FaServer />,
        title: "Centralized Security Dashboard",
    },
    {
        icon: <FaUsb />,
        title: "USB & Device Control",
    },
    {
        icon: <FaChartLine />,
        title: "Security Analytics & Reporting",
    },
    {
        icon: <FaSyncAlt />,
        title: "Automatic Security Updates",
    },
    {
        icon: <FaShieldAlt />,
        title: "Zero Trust Endpoint Security",
    },
];

const HomeProduct = () => {
    return (
        <section className="home-product">

            <div className="container">

                <motion.div
                    className="product-wrapper"
                    initial={{ opacity: 0, y: 60 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    {/* LEFT SIDE */}

                    <motion.div
                        className="product-image"
                        initial={{ opacity: 0, x: -60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >

                        <img
                            src={productImage}
                            alt="BlueLotus SecureShield"
                        />

                    </motion.div>

                    {/* RIGHT SIDE */}

                    <motion.div
                        className="product-content"
                        initial={{ opacity: 0, x: 60 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >

                        <span className="section-tag">

                            <FaShieldAlt />

                            Featured Product

                        </span>

                        <h2>

                            BlueLotus Infrasafety Projects Private Limited
                            <span> SecureShield</span>

                        </h2>

                        <h4>

                            Enterprise Endpoint Security Platform

                        </h4>

                        <p>

                            BlueLotus Infrasafety Projects Private Limited SecureShield is an intelligent
                            endpoint security platform engineered to
                            protect desktops, laptops, workstations,
                            and enterprise servers against evolving
                            cyber threats.

                        </p>

                        <p>

                            Combining Artificial Intelligence,
                            behavioral analytics, and real-time
                            monitoring, SecureShield proactively
                            prevents ransomware, malware,
                            phishing attacks, unauthorized access,
                            and advanced persistent threats before
                            they disrupt your business operations.

                        </p>

                        {/* FEATURES */}

                        <div className="product-features">

                            {features.slice(0, 4).map((item, index) => (

                                <div
                                    className="feature-box"
                                    key={index}
                                >

                                    <div className="feature-icon">

                                        {item.icon}

                                    </div>

                                    <span>

                                        {item.title}

                                    </span>

                                </div>

                            ))}

                            {features.slice(4).map((item, index) => (

                                <div
                                    className="feature-box"
                                    key={index + 4}
                                >

                                    <div className="feature-icon">

                                        {item.icon}

                                    </div>

                                    <span>

                                        {item.title}

                                    </span>

                                </div>

                            ))}

                        </div>

                        {/* PRODUCT HIGHLIGHTS */}

                        <div className="product-highlights">

                            <div className="highlight-card">

                                <h3>99.9%</h3>

                                <p>Threat Detection Accuracy</p>

                            </div>

                            <div className="highlight-card">

                                <h3>24×7</h3>

                                <p>Continuous Protection</p>

                            </div>

                            <div className="highlight-card">

                                <h3>AI</h3>

                                <p>Powered Security Engine</p>

                            </div>

                        </div>

                        {/* CTA */}

                        <div className="product-buttons">

                            <a
                                href="/bluelotus-secureshield"
                                className="primary-btn"
                            >

                                Explore Product

                                <FaArrowRight />

                            </a>

                        </div>

                    </motion.div>

                </motion.div>

            </div>

        </section>

    );
};

export default HomeProduct;